import { IsNotNull, GetBlob } from '../../helpers/helper';


const getBlobS3 = async (b) => {
  let result = null
  // let url = process.env.REACT_APP_API_URL + "get-ps-url"
  let url = process.env.REACT_APP_API_URL + "get-blob-s3"
  await GetBlob(b, url).then(x => { result = IsNotNull(x) ? x : null })
  return result;
}

export {
  getBlobS3
}